import React from 'react'
import GlobalLayout from '../components/GlobalLayout'
import * as listingsService from "../services/listings";
import { logOrThrowError } from "../utility/logging";
import { captureQueryParams } from "../services/trackingParams";

export default class GlobalLayoutContainer extends React.Component {
  constructor(props) {
    super(props);

    const preloadedData = this.props.preloadedData;
    this.state = {
      utm_params: (this.getQueryString().toString().includes("utm") || this.getQueryString().toString().includes("UTM")) ? this.getQueryString().toString() : "",
      // listings keyed by id, in a normalized form combining data from
      // nestio with local data in a cookie about whether the listing is saved.
      // This is all our application state. It's undefined if the listings are
      // unfetched, and can hold an error if the fetch failed.
      listings: preloadedData && preloadedData.listings ?
        listingsService.recomputeSavedListings(preloadedData.listings) :
        undefined
    };

    // Read the tracking params from the initial url hit when the app is
    // loaded (which is also when this container component is constructed).
    // Those are the params we use for rendering all the rest of the pages,
    // even though we don't keep them in the url on subsequent navigations.
    // Note: because this code runs on the server too, we have to read the
    // query param from the route (which we're setting on the server),
    // rather than from window.location (which won't exist server-side).
    // We can't just use a blank query string server side, as that could get
    // us into trouble with Google's policies (it could think we're cloaking).
    // TODO: bc query params can effect render, we should eventually move them
    // to this.state, rather than keeping them in the tracking params service's global.
    captureQueryParams((this.props.location && this.props.location.search) || "");

    this.syncListings = this.syncListings.bind(this);
    this.toggleListingSaved = this.toggleListingSaved.bind(this);
  }
  componentDidMount() {
    let query = this.getQueryString().toString();
    if (query !== 'undefined' && query !== "" && (query.includes("utm") || query.includes("UTM"))) {
      this.setState({ utmParams: query });
    }
  }
  // Conditionally fetch listings and add them to the state
  // if they're not they're already. Right now, this is limited because we
  // can only fetch all the listings at once. In the future, more filters
  // might be supported.
  syncListings(options = {}) {
    const id = options.filters && options.filters.id;
    const listingsNeedFetch = (
      this.state.listings === undefined ||
      this.state.listings instanceof Error ||
      (id && !this.state.listings[id])
    );

    const allListingsPromise = listingsNeedFetch ?
      listingsService.loadAllListings().catch(err => err) :
      Promise.resolve(this.state.listings);

    // Specifically mark a listing as not found,
    // if it was requested directly but not returned.
    // This is kinda weird, but an artifact of our fetching strategy.
    allListingsPromise.then(listingsState => {
      return (id && !listingsState[id]) ?
        {
          ...listingsState,
          [id]: new Error("Listing not found.")
        } :
        listingsState;
    }).then(finalListingsState => {
      if (finalListingsState !== this.state.listings) {
        this.setState({ listings: finalListingsState });
      }
    });
  }

  toggleListingSaved(id) {
    if (!(this.state.listings && this.state.listings[id])) {
      logOrThrowError(new Error("Shouldn't call toggleListingSaved until you've loaded the listings."));
    }

    const updateListingSaved = this.state.listings[id].isSaved ?
      listingsService.unmarkListingAsSaved :
      listingsService.markListingAsSaved;

    updateListingSaved(id);

    this.setState({
      listings: {
        ...this.state.listings,
        [id]: { ...this.state.listings[id], isSaved: !this.state.listings[id].isSaved }
      }
    });
  }
  getQueryString() {
    return window.location.search.substring(1).split("&").reduce((sum, param) => { const [key, val] = param.split("="); sum.push(`${key}: ${val}`); return sum; }, []);

  }
  render() {
    const baseUrl = this.props.preloadedData && this.props.preloadedData.baseUrl
      || typeof window !== undefined ? 
      "https://300ashland.com/" : "";
      
    return <GlobalLayout
      listings={this.state.listings}
      syncListings={this.syncListings}
      toggleListingSaved={this.toggleListingSaved}
      baseUrl={baseUrl}
      utmParams={this.state.utm_params}
      {...this.props}>
      {this.props.children}
    </GlobalLayout>;
  }
}


// WEBPACK FOOTER //
// ./client/containers/GlobalLayoutContainer.js